    import React from "react"


class Users extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            }
    }

    render() {
        return (
            <section>
                
                <div className="head-content "> 
                    <div className="col-md-8 px-2">     
                        <h1>Configuración</h1>
                        <h2>USUARIOS / ROLES</h2>
                    </div>
                    <div className="col-md-4 px-2 users-available">
                      <h3 className="color-blue"><b>USUARIOS DISPONIBLES </b></h3>
                      <p className="number-user">4/10</p>      
                    </div>
                </div> 
                <div className="box regular col-md-12">
                   <h3 className="title-roles-h3"> <b>USUARIOS ACTIVOS</b>
                     <select className="account-select top-form-select select-roles">
                         <option>Hola</option>
                     </select>
                    </h3>
                    <table className="table-account-info">
                     <thead>
                          <tr className="tr-account-info">
                              <th>NOMBRE</th>
                              <th>TIPO</th>
                              <th>ROL</th>
                              <th>MÓDULO</th>
                              <th>DASHBOARD</th>
                              <th>HOTEL(ES)</th>
                              <th>ULT.ACCESO</th>
                              <th>INICIOS DE SESIÓN</th>
                              <th>ALERTAS CREADAS</th>
                              <th>ACCIONES</th>
                          </tr>
                     </thead>
                     <tbody>
                         <tr>
                           <td>Antonio Mendoza Navarrete</td>  
                           <td>Incluido</td>
                           <td>Operador</td>
                           <td> <span className="table-module"> <img className="icon-small" src="../../images/RI.svg" /> RI</span> </td>
                           <td><span className="table-df-icon"> <img  className="icon-small svg-color-white" src="../../images/DFS.svg" /> DF</span> <span className="table-module"> <img className="icon-small" src="../../images/LTM.svg" /> LT</span>  </td>
                           <td> <span className="table-hotels">GB</span> <span className="table-hotels">MSL</span> <span className="table-hotels">VDP</span> <span className="table-hotels">HM</span> </td>
                           <td>20/ENE/2018</td>
                           <td>12</td>
                           <td>5</td>
                           <td>
                             <div className="action-elements">  
                               <img className="action-element-icon" src="../../images/edit.svg"  />
                               <img className="action-element-icon" src="../../images/cerrar.svg"/>
                               <label className="switch">
                                    <input type="checkbox" />
                                     <span className="slider round"></span>
                                </label>
                            </div>
                            </td>
                         </tr>     
                    </tbody>        
                    </table>
                </div>
                <div className="col-md-12 container-img">
                    <button className="button-roles">AGREGAR NUEVO USUARIO</button>
                    <img className="image-add-user" src="../../images/rolesImg.jpeg" />
                </div> 
            </section>
        )
    }

}

export default Users


// WEBPACK FOOTER //
// ./src/Setup/modules/setup/views/corporative/Users.js